import * as React from 'react';
import { useAuthOverlay } from '../../context/AuthOverlayContext';
import LoginModal from './LoginModal';
import RegisterModal from './RegisterModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import ResetPasswordModal from './ResetPasswordModal';

/**
 * Ce composant doit être monté SOUS <Router> et DANS <AuthOverlayProvider>.
 * Il rend les 4 modales et fournit un pont optionnel window.openAuth(...)
 */
export default function AuthOverlayHost() {
  const {
    loginOpen, registerOpen, forgotOpen, resetOpen, resetToken,
    openLogin, openRegister, openForgot, openReset, closeAll,
  } = useAuthOverlay();

  // Pont global optionnel : window.openAuth('login' | 'register' | 'forgot' | 'reset', opts?)
  React.useEffect(() => {
    const fn = (screen, opts = {}) => {
      switch (screen) {
        case 'login':    openLogin(opts); break;
        case 'register': openRegister(opts); break;
        case 'forgot':   openForgot(); break;
        case 'reset':    openReset(opts); break;
        default: break;
      }
    };
    window.openAuth = fn;
    return () => { if (window.openAuth === fn) delete window.openAuth; };
  }, [openLogin, openRegister, openForgot, openReset]);

  return (
    <>
      <LoginModal
        open={loginOpen}
        onClose={closeAll}
        onOpenRegister={() => openRegister()}
        onOpenForgot={() => openForgot()}
        // Laisse la modale appliquer l'auto-redirect (comme pages)
        // Si tu veux intercepter: passe onLoggedIn={(auth)=> ...}
      />

      <RegisterModal
        open={registerOpen}
        onClose={closeAll}
        onOpenLogin={() => openLogin()}
        // Auto-login + auto-redirect comme les pages.
        // Pour intercepter: onRegistered={(auth)=> ...}
      />

      <ForgotPasswordModal
        open={forgotOpen}
        onClose={closeAll}
      />

      <ResetPasswordModal
        open={resetOpen}
        token={resetToken}
        onClose={closeAll}
        // onResetDone={() => ...}
      />
    </>
  );
}